module.exports = __webpack_public_path__ + "static/hero-c1a272fa91d1d29ab8bd6f0320e6ee12.jpg";